import { BASE_CONFIG, USER } from "libs/config";
import axios from "axios";
import Constants from "expo-constants";
import { HasValidToken } from "./auth.service";
import { store } from "src/common/toolkit/store";
import {
  login,
  clearData,
  updateToken,
} from "src/common/toolkit/features/auth";
import { openToast } from "src/common/toolkit/features/toast";
import translate from "../locale";

const _axios = axios.create();
const extras = Constants.expoConfig?.extra;
const client = extras?.client || process.env.CLIENT;

const refreshToken = async (rt) => {
  const headers = { "refresh-token": rt };
  return PublicGet(USER.refresh, null, headers);
};

_axios.interceptors.request.use(
  async (config) => {
    try {
      const state = store?.getState();
      const { rt, t } = state?.auth?.data || {};
      if (!HasValidToken(t) && HasValidToken(rt)) {
        const newToken = await refreshToken(rt);
        store.dispatch(updateToken({ ...newToken.data.payload }));
        SetPrivateAxios(newToken.data.payload.t);
        config.headers.Authorization = newToken.data.payload.t;
      } else if (!HasValidToken(t) && !HasValidToken(rt)) {
        const requestAuthToken = config?.headers?.Authorization;
        if (HasValidToken(requestAuthToken.toString())) {
          return config;
        }
        if (client === "merchant") {
          store.dispatch(clearData());
        } else {
          store.dispatch(login({ guest: true }));
        }
        store.dispatch(openToast({ message: translate("sessionExpired") }));
        return;
      }
    } catch (error) {
    } finally {
    }
    return config;
  },
  (error) => {
    console.error("Request interceptor error:", error);
    return Promise.reject(error);
  }
);

function SetPrivateAxios(token?: string) {
  if (token) {
    _axios.defaults.headers.common["Authorization"] = token;
  }
}

// PRIVATE APIs
/* @Params  {Object} query {userId:23,limit:20}*/
function Get<T>(url, query = {}, headers = {}) {
  const apiURL = BASE_CONFIG.api_url;
  const config = { headers };
  const search = new URLSearchParams();
  for (let key in query) {
    search.append(key, query[key]);
  }
  const _search = search.toString();
  const _url = `${apiURL}${url}${
    query && Object.keys(query).length ? "?" + _search : ""
  }`;
  return _axios.get<T>(_url, config);
}
/* @Params  {Object} query {userId:23,limit:20}*/
function Post<T>(url, body, query = {}, headers = {}) {
  const apiURL = BASE_CONFIG.api_url;
  const config = { headers };
  const search = new URLSearchParams();
  for (let key in query) {
    search.append(key, query[key]);
  }
  const _search = search.toString();
  const _url = `${apiURL}${url}${
    query && Object.keys(query).length ? "?" + _search : ""
  }`;
  return _axios.post<T>(_url, body, config);
}
/* @Params  {Object} query {userId:23,limit:20}*/
function Patch<T>(url, body, query = {}, headers = {}) {
  const apiURL = BASE_CONFIG.api_url;
  const config = { headers };
  const search = new URLSearchParams();
  for (let key in query) {
    search.append(key, query[key]);
  }
  const _search = search.toString();
  const _url = `${apiURL}${url}${
    query && Object.keys(query).length ? "?" + _search : ""
  }`;
  return _axios.patch<T>(_url, body, config);
}
/* @Params  {Object} query {userId:23,limit:20}*/
function Delete(url) {
  const apiURL = BASE_CONFIG.api_url;
  const _url = `${apiURL}${url}`;
  return _axios.delete(_url);
}

// PUBLIC APIs
const _axiosPublic = axios.create();
// For Login,...
function PublicGet(url, query = {}, headers = {}) {
  const apiURL = BASE_CONFIG.base_url;
  const config = { headers };
  const search = new URLSearchParams();
  for (let key in query) {
    search.append(key, query[key]);
  }
  const _search = search.toString();
  const _url = `${apiURL}${url}${
    query && Object.keys(query).length ? "?" + _search : ""
  }`;
  return _axiosPublic.get(_url, config);
}
// For Register,...
function PublicPost(url, query = {}, body = {}, headers = {}) {
  const apiURL = BASE_CONFIG.base_url;
  const config = { headers };
  const search = new URLSearchParams();
  for (let key in query) {
    search.append(key, query[key]);
  }
  const _search = search.toString();
  const _url = `${apiURL}${url}${
    query && Object.keys(query).length ? "?" + _search : ""
  }`;
  return _axiosPublic.post(_url, body, config);
}

export { Get, Post, Patch, Delete, PublicGet, PublicPost, SetPrivateAxios };
